import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import PreviousEntityTypeName from '../PreviousEntityTypeName';

// // Selectors
import { makeSelectHarvestSchemaValue } from '../../services/schemas/selectors';

interface Props {
    entityTypeId?: number;
}

export class HarvestEventTypeSchemaParentEntityTypeName extends React.PureComponent<Props> {
    render() {
        const { entityTypeId } = this.props;
        return <PreviousEntityTypeName entityTypeId={entityTypeId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectHarvestSchemaValue('entityTypeId')
});

export default connect(mapStateToProps)(
    HarvestEventTypeSchemaParentEntityTypeName
);
